export var extractTaskStatus = function extractTaskStatus(jsonLd) {
  var taskStatus = jsonLd['atlassian:taskStatus'];
  if (taskStatus && taskStatus.name) {
    return {
      text: taskStatus.name,
      appearance: 'success'
    };
  }
};